import React, { useState, useEffect } from "react";
import "./HeaderSignup.css";
import { useLocation } from "react-router-dom";
interface HeaderSignupProps {
  styleProps?: string;
  onBack?: () => void;
}

const BackArrow = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 11 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.46967 6.16998C0.176777 5.87709 0.176777 5.40221 0.46967 5.10932L5.24264 0.336348C5.53553 0.0434546 6.01041 0.0434546 6.3033 0.336348C6.59619 0.629241 6.59619 1.10411 6.3033 1.39701L2.06066 5.63965L6.3033 9.88229C6.59619 10.1752 6.59619 10.6501 6.3033 10.9429C6.01041 11.2358 5.53553 11.2358 5.24264 10.9429L0.46967 6.16998ZM11 6.38965L1 6.38965L1 4.88965L11 4.88965L11 6.38965Z"
        fill="#C0C0C0"
      />
    </svg>
  );
};

const HeaderSignup: React.FC<HeaderSignupProps> = ({ styleProps, onBack }) => {
  const [showMobileBackArrow, setShowMobileBackArrow] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const updateBackArrow = () => {
      const isNewFunnel = localStorage.getItem("isNewFunnel") === "true";
      const isMobile = window.innerWidth <= 600;
      const match = location.pathname.match(
        /^\/getting-started\/step-(\d+|13b)$/
      );
      const stepNumber = match ? String(match[1]) : null;

      const isEligibleStep =
        stepNumber === "13b" || (stepNumber && parseInt(stepNumber, 10) <= 14);

      setShowMobileBackArrow(
        Boolean(isNewFunnel && isMobile && isEligibleStep)
      );
    };

    updateBackArrow(); // run initially
    window.addEventListener("resize", updateBackArrow); // run on resize

    return () => window.removeEventListener("resize", updateBackArrow);
  }, [location.pathname]);

  return (
    <header className={`sign-header ${styleProps}`}>
    {showMobileBackArrow && onBack && (
      <button className="arrow-btn" onClick={onBack}>
        <BackArrow />
      </button>
    )}
    <img src="/images/clogo.png" alt="Claya Logo" className="header-logo" />
  </header>
  );
};

export default HeaderSignup;
